'use client'

import { PropsWithChildren, useTransition } from 'react'
import { Box } from '@chakra-ui/react'

import Pagination from 'app/components/shared/Pagination'
import { Metadata } from 'appTypes/shared'
import { Loader } from 'components/ui/Loader'

type Props = PropsWithChildren & {
  metadata: Metadata | undefined
  query: {
    [key: string]: string | string[] | undefined
  }
}

const ArticlesNavigationContext = ({
  children,

  metadata,
  query,
}: Props): JSX.Element => {
  const [isPending, startTransition] = useTransition()

  return (
    <>
      <Box minHeight="57vh">{isPending ? <Loader /> : <>{children}</>}</Box>

      {metadata?.last !== undefined && metadata?.last > 1 && (
        <Box marginBottom="32px">
          <Pagination
            queryParams={query}
            pageCount={metadata.last}
            currentPage={metadata.page}
            startTransition={startTransition}
          />
        </Box>
      )}
    </>
  )
}

export default ArticlesNavigationContext
